
const server={
    dev:"http://localhost:8000",
    prod:"https://convox-meet-backend.onrender.com"
}

export default server;